const modal = document.getElementById("ModalText2");
const openBtn = document.getElementById("openModalText2");
const closeBtn = document.getElementById("closeModalText2");

// Open the modal when the button is clicked
openBtn.onclick = function() {
  modal.style.display = "block";
}

// Close the modal when 'X' is clicked
closeBtn.onclick = function() {
  modal.style.display = "none";
}

// Close the modal if the user clicks anywhere outside the content box
// window.onclick = function(event) {
//   if (event.target == modal) {
//     modal.style.display = "none";
//   }
// }

// window.addEventListener("keydown", function(event) {
//   if (event.key === "Escape") {
//     modal.style.display = "none";
//   }
// });

const modalfourth = document.getElementById("ModalText4");
const openBtnFourth = document.getElementById("openModalText4");
const closeBtnFourth = document.getElementById("closeModalText4");

// Open the modal when the button is clicked
openBtnFourth.onclick = function() {
  modalfourth.style.display = "block";
}

// Close the modal when 'X' is clicked
closeBtnFourth.onclick = function() {
  modalfourth.style.display = "none";
}

// Close the modal if the user clicks anywhere outside the content box
window.onclick = function(event) {
  if (event.target == modal) {
    modal.style.display = "none";
  }

  if (event.target == modalfourth) {
    modalfourth.style.display = "none";
  }
}

window.addEventListener("keydown", function(event) {
  if (event.key === "Escape") {
    modalfourth.style.display = "none";
    modal.style.display = "none";
  }
});